import React, { createContext } from "react";

export const NavigationContext = createContext({
  isSideBarOpen: false,
  toggleSideBar: () => {},
});
